import React from 'react';
import { providerSubmitSessionRoute } from '@uplift/constants';
import { useL10n } from '@uplift/hooks';
import { Appointment } from '@uplift/api';
import { Link } from 'react-router-dom';
import { Button, ButtonProps } from '../../../../Button';

export const SubmitSessionButton: React.FC<
{
  appointment?: Appointment;
} & ButtonProps
> = ({ appointment, ...props }) => {
  const l10n = useL10n();
  const submitSessionLink = appointment?.id
    ? providerSubmitSessionRoute.createLink(
      { appointmentId: appointment?.id },
      { redirect_to: '/notsubmitted-sessions' },
    )
    : '';
  const isDisabled = appointment?.state !== 'completed';

  return (
    <Button {...props} component={Link} to={submitSessionLink} disabled={isDisabled}>
      {l10n.sessions.submitSession}
    </Button>
  );
};
